import React, { memo } from 'react';
import styled, { css } from 'styled-components';
import { type ReactPlayerProps } from 'react-player/lazy';

import dynamic from 'next/dynamic';
import { fadeTranslateIn } from '../styles/animations';
import COLORS from '../styles/colors';

import Icon from './Icon';

const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });
const Modal = dynamic(() => import('./Modal'), { ssr: false });

type ContentProps = { $show: boolean; $fullScreen: boolean };

const VideoContainer = styled.div<ContentProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 1180px;
  width: 100%;
  opacity: 0;
  ${(props) =>
    props.$show &&
    css`
      animation: ${fadeTranslateIn(0, 48)} 1s ease-out;
      animation-fill-mode: both;
    `};

  pointer-events: all;

  & .videoContainer {
    display: flex;
    box-shadow: 0px 0px 1px ${COLORS.brand.regular.opacity(0.2)},
      0px 4px 100px ${COLORS.brand.regular.opacity(0.1)};
    border: 2px solid ${COLORS.brand.mid.css};
    border-radius: 6px;
    overflow: hidden;

    ${(props) => {
      if (props.$fullScreen) {
        return css`
          width: 100%;
          padding-top: 56.25%;
          position: relative;
          background: ${COLORS.black.css};
          & > div {
            top: 0;
            left: 0;
            position: absolute;
          }
        `;
      }
      return css``;
    }}
  }
`;

const Close = styled.button`
  pointer-events: all;
  color: ${COLORS.white.css};
  margin-left: auto;
`;

type ModalVideoProps = ReactPlayerProps & {
  open: boolean;
  setOpen: (value: boolean) => void;
};
function ModalVideo({ data, open, setOpen, ...props }: ModalVideoProps) {
  return (
    <Modal isOpen={open} onRequestClose={() => setOpen(false)}>
      <Close onClick={() => setOpen(false)}>
        <Icon name="X" width={24} height={24} />
      </Close>
      <VideoContainer $show $fullScreen>
        <ReactPlayer
          muted={false}
          playing
          playsinline
          controls
          {...props}
          className="videoContainer"
        />
      </VideoContainer>
    </Modal>
  );
}

export default memo(ModalVideo);
